import { render } from "./PurchaseOrders.vue?vue&type=template&id=39df0b56&scoped=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js"

import "./PurchaseOrders.vue?vue&type=style&index=0&id=39df0b56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39df0b56"]])

export default __exports__